import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { listDecks } from "@/lib/idb";
import { createNewDeck } from "@/store/bootstrap";
import { DeckSkeleton } from "@/store/HydrationGate";

// `/` — the entry point, which since §12 is a *decision* rather than a page (TODO §12.1.1).
//
//   nothing stored  → mint a deck and open it. First-time users land in the editor, exactly
//                     as they did when the app booted straight into its one seeded deck.
//   one deck        → open it. A single-deck user should never be made to pick from a list
//                     of one.
//   several decks   → the documents home, which is the honest answer to "which one?".
//
// Replaces the history entry in every case: `/` is a redirect, and leaving it on the stack
// would make Back bounce the user straight forward again.
export function DeckLanding() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const decks = await listDecks();
      if (cancelled) return;
      if (decks.length > 1) {
        navigate("/documents", { replace: true });
        return;
      }
      // Already sorted by `updatedAt`, so [0] is the most recently touched deck.
      const deckId = decks[0]?.deckId ?? (await createNewDeck());
      if (!cancelled) navigate(`/d/${deckId}`, { replace: true });
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return <DeckSkeleton />;
}
